import { configureStore, ThunkAction, Action } from "@reduxjs/toolkit";
import profileSlice from "./libs/profileSlice";

export const store = configureStore({
  reducer: {
    profile: profileSlice,
  },
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
